import { defineMessages } from 'react-intl';

const messages = defineMessages({
  leaveCommentLabel: {
    id: 'LessonDetails.leaveCommentLabel',
    defaultMessage: 'Leave your comment at {time}',
    description: 'label displayed in lesson details',
  },
  privateLabel: {
    id: 'LessonDetails.privateLabel',
    defaultMessage: 'Private',
    description: 'label displayed in lesson details',
  },
  savingLabel: {
    id: 'LessonDetails.savingLabel',
    defaultMessage: 'Saving...',
    description: ' Button label displayed in lesson details',
  },
  sourcesLabel: {
    id: 'LessonDetails.sourcesLabel',
    defaultMessage: 'Sources',
    description: ' "Sources" label displayed in lesson details',
  },
  saveLabel: {
    id: 'LessonDetails.saveLabel',
    defaultMessage: 'Save',
    description: ' Button label displayed in lesson details',
  },
  backToTitle: {
    id: 'LessonDetails.backToTitle',
    defaultMessage: 'Back to {name}',
    description: 'Tooltip title displayed displayed in lesson details',
  },
  upNextText: {
    id: 'LessonDetails.upNextText',
    defaultMessage: 'Up next:',
    description: 'Title displayed in videoplayer in lesson details',
  },
  noteSuccessAddMsg: {
    id: 'LessonDetails.noteSuccessAddMsg',
    defaultMessage: 'The note has been added to the timeline',
    description:
      'Success note added message displayed at snackbar in lesson details',
  },
  browserDoesntSupportAudioMsg: {
    id: 'LessonDetails.browserDoesntSupportAudioMsg',
    defaultMessage: 'Your browser does not support the audio element.',
    description: 'Message displayed at audio area in lesson details',
  },
  addNoteLabel: {
    id: 'LessonDetails.addNoteLabel',
    defaultMessage: 'Add note',
    description: 'Add note button title displayed in lesson details',
  },
  hideNotesTitle: {
    id: 'LessonDetails.hideNotesTitle',
    defaultMessage: 'Hide notes',
    description: 'Tooltip title displayed in lesson details',
  },
  showNotesTitle: {
    id: 'LessonDetails.showNotesTitle',
    defaultMessage: 'Show notes',
    description: 'Tooltip title displayed in lesson details',
  },
  notesBtnTitle: {
    id: 'LessonDetails.notesBtnTitle',
    defaultMessage: 'Notes',
    description: 'Button label displayed in lesson details',
  },
  completingBtnMsg: {
    id: 'LessonDetails.completingBtnMsg',
    defaultMessage: 'Completing lesson...',
    description: 'Button label displayed in lesson details',
  },
  completedBtnMsg: {
    id: 'LessonDetails.completedBtnMsg',
    defaultMessage: 'Completed! Rate content',
    description: 'Button label displayed in lesson details',
  },
  completedOfflineBtnMsg: {
    id: 'LessonDetails.completedOfflineBtnMsg',
    defaultMessage: 'Completed',
    description: 'Button label displayed in lesson details in offline mode',
  },
  completeBtnmsg: {
    id: 'LessonDetails.completeBtnmsg',
    defaultMessage: 'Complete',
    description: 'Button label displayed in lesson details',
  },
  nextBtnTooltip: {
    id: 'LessonDetails.nextBtnTooltip',
    defaultMessage: 'Next: {name}',
  },
  nextBtnLabel: {
    id: 'LessonDetails.nextBtnLabel',
    defaultMessage: 'Next',
  },
  showCertificateBtnLabel: {
    id: 'LessonDetails.showCertificateBtnLabel',
    defaultMessage: 'Show course certificate',
    description: 'Button shown when course is completed',
  },
  completedLessonsInSection: {
    id: 'LessonDetails.completedLessonsInSection',
    defaultMessage:
      '{completedLessons} completed lesson(s) of {totalLessons} total lesson(s) in the section',
    description: 'Tooltip label displayed in lesson details',
  },
  thereIsNoNotesYet: {
    id: 'LessonDetails.thereIsNoNotesYet',
    defaultMessage: 'No notes to show yet',
    description:
      'Tooltip label displayed over notes button in case there is no added notes yet',
  },
  highlightLabel: {
    id: 'LessonDetails.highlightLabel',
    defaultMessage: 'Highlight',
  },
  privateCheckboxHint: {
    id: 'LessonDetails.privateCheckboxHint',
    defaultMessage: '(Don’t show in course discussion)',
  },
  cancel: {
    id: 'LessonDetails.cancel',
    defaultMessage: 'Cancel',
  },
  isTranscoding: {
    id: 'LessonDetails.isTranscoding',
    defaultMessage: 'Video is still being transcoded, try again soon',
  },
  close: {
    id: 'General.closeLabel',
    defaultMessage: 'close',
  },
  clickOnVideoToExitFullScreen: {
    id: 'LessonDetails.clickOnVideoToExitFullScreen',
    defaultMessage: 'Click on video to exit fullscreen',
  },
  optionIsNotAvailableForTrial: {
    id: 'LessonDetails.optionIsNotAvailableForTrial',
    defaultMessage: 'Changing this option is not available for Trial users',
  },
  notAvailableInOfflineMode: {
    id: 'LessonDetails.notAvailableInOfflineMode',
    defaultMessage: 'Not available in offline mode',
  },
  notAvailableOffline: {
    id: 'LessonDetails.notAvailableOffline',
    defaultMessage: '(not available offline)',
  },
  switchToVideoView: {
    id: 'LessonDetails.switchToVideoView',
    defaultMessage: 'Switch to Video view',
  },
  switchToAudioView: {
    id: 'LessonDetails.switchToAudioView',
    defaultMessage: 'Switch to Audio view',
  },
  switchToTextView: {
    id: 'LessonDetails.switchToTextView',
    defaultMessage: 'Switch to Text view',
  },
  course: {
    id: 'LessonDetails.course',
    defaultMessage: 'Course',
  },
  changeLogMenuItem: {
    id: 'LessonDetails.changeLogMenuItem',
    defaultMessage: 'Current lesson changelog',
  },
  changelog: {
    id: 'LessonDetails.changelog',
    defaultMessage: '{name} - Changelog',
  },
  serviceNamePossessive: {
    id: 'LessonDetails.defaultServiceNamePossessive',
    defaultMessage: 'Skhole',
  },
  leaveCourseRating: {
    id: 'LessonDetails.leaveCourseRating',
    defaultMessage: 'Leave course rating',
  },
  editCourseRating: {
    id: 'LessonDetails.editCourseRating',
    defaultMessage: 'Edit course rating',
  },
  videoCommentAriaLabel: {
    id: 'LessonDetails.videoCommentAriaLabel',
    defaultMessage: 'Video comment',
  },
  emptyContentMessage: {
    id: 'LessonDetails.emptyContentMessage',
    defaultMessage:
      'This lesson has no text format available. However, you can listen to it as audio track instead',
  },
  attachedCoursesByUsersBtn: {
    id: 'LessonDetails.attachedCoursesByUsersBtn',
    defaultMessage: 'See courses on this topic',
  },
  attachedCoursesByUsersBtnTooltip: {
    id: 'LessonDetails.attachedCoursesByUsersBtnTooltip',
    defaultMessage: 'Show courses that include this lesson',
  },
});

export default messages;
